export default function CardContent({ currentCard, flipStatus }) {
  const { note, imgUrl, position, string } = currentCard;

  if (!flipStatus) {
    return (
      <div className='front'>
        <img
          id='card-image'
          src={`../images/${imgUrl}.jpeg`}
          alt={`notation of the ${note} note on the ${string} string`}
        />
      </div>
    );
  } else if (flipStatus) {
    return (
      <div className='back'>
        <p>
          {note} on the {string} string at position {position}
        </p>
      </div>
    );
  }
}
